import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import TagManagerService from 'services/TagManager';
import PropTypes from "prop-types";

const Metas = (props) => {

    useEffect(() => {
        TagManagerService.changePage();
    },[])
    return <Helmet>
        {props.children}
    </Helmet>


}

Metas.propTypes = {
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};

export default Metas;
